import {FieldValues, Path, UseFormRegister, FieldErrors, RegisterOptions} from 'react-hook-form'
import {getFieldError} from './getFieldError'

interface CheckboxInputProps<T extends FieldValues> {
  name: Path<T>
  label: string | React.ReactNode
  register: UseFormRegister<T>
  errors?: FieldErrors<T>
  required?: boolean
  className?: string
  inputClassName?: string
  helperText?: string
  specialText?: string
  isChecked?: boolean // Initial state
  onChange?: (checked: boolean) => void
  options?: RegisterOptions<T, Path<T>>
}

export const CheckboxInput = <T extends FieldValues>({
  name,
  label,
  register,
  errors,
  required = false,
  className = '',
  helperText = '',
  specialText = '',
  inputClassName = '',
  isChecked = false,
  onChange,
  options = {},
}: CheckboxInputProps<T>) => {
  const error = getFieldError(errors, name)

  return (
    <div className={`mb-3 form-check ${className}`}>
      <div>
        <input
          type='checkbox'
          id={String(name)}
          className={`form-check-input ${inputClassName} `}
          defaultChecked={isChecked}
          {...register(name, {
            ...options,
            required: required ? 'This field is required' : false,
            setValueAs: (v) => !!v,
            onChange: (e) => {
              const checked = e.target.checked
              if (onChange) onChange(checked)
            },
          })}
        />
        <label htmlFor={String(name)} className='form-check-label mb-1'>
          {label} {required && <span className='text-danger'>*</span>}
        </label>
        {specialText && (
          <span className='special-text'>
            <span></span> {specialText}
          </span>
        )}
        {error && <div className='text-danger mt-1'>{String(error.message)}</div>}
      </div>
      {helperText && <small className='text-muted d-block fs-6'>{helperText}</small>}
    </div>
  )
}
